import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'sym-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  endPoint = environment.api.loginAPI;

  logoStyle = {
    'object-fit': 'contain',
    'height': '80px'
  };
  constructor() { }

  ngOnInit(): void {
  }

}
